import { Link } from "react-router-dom";
import estilos from "./Sobre.module.css";

function Sobre() {
    return (
        <div className={estilos.container}>  
            <div className={estilos.banner}>
                <h2>SEJA BEM-VINDO!</h2>
                <h2>Conheça os personagens: 
                    <br/><br/>
                    <a className={estilos.btPersonagem}><Link to="/personagens">Ver personagens</Link></a>
                </h2>
            </div>

            <img src="./imagens/logo.png" alt="Imagem da logo" className={estilos.logo}/>

            <p>Dragon Ball é uma das franquias mais influentes das obras japonesas, criada por Akira Toriyama. A série teve início como um mangá em 1984 e rapidamente se expandiu para o anime, filmes, jogos e outros produtos. A história acompanha as aventuras de Son Goku, um guerreiro saiyajin que, desde criança, treina para se tornar o mais forte do universo. Ao longo de sua jornada, Goku enfrenta inimigos poderosos, forma alianças duradouras e busca as misteriosas Esferas do Dragão, que podem realizar qualquer desejo quando reunidas.</p>
            
            <div className={estilos.secaoHistoria}>
                <h3>História de Dragon Ball</h3>
                <p>Dragon Ball começou como um mangá publicado na revista Weekly Shōnen Jump. A história é inspirada em “Viagem ao Oeste”, um clássico da literatura chinesa, mas foi adaptada com uma abordagem moderna e inovadora. O mangá foi tão popular que levou à criação do anime, que começou a ser exibido em 1986. Dragon Ball Z, uma continuação da série original, foi lançado em 1989 e se tornou ainda mais famoso, introduzindo novos personagens e aumentando a escala das batalhas.</p>
            </div>

            <div className={estilos.secaoDragonBalls}>
                <h3>Tipos de Dragon Balls</h3>
                <p>As Dragon Balls são esferas mágicas que, quando reunidas, podem conceder um desejo ao seu possuidor. Existem diferentes tipos de Dragon Balls, cada uma com suas próprias características:</p>
                <ul>
                    <li><strong>Dragon Balls Terrestres:</strong> Existem sete Dragon Balls na Terra. Cada esfera possui uma estrela que varia de uma a sete. Elas são usadas principalmente na série original e em Dragon Ball Z.</li>
                    <li><strong>Dragon Balls do Planeta Namek:</strong> São esferas de tamanho maior, também com sete esferas, e têm a capacidade de realizar desejos semelhantes às Dragon Balls Terrestres. Elas aparecem em Dragon Ball Z.</li>
                    <li><strong>Black Star Dragon Balls:</strong> Um conjunto de Dragon Balls que, ao serem usadas, trazem grandes consequências para o universo. Elas são apresentadas em Dragon Ball GT.</li>
                </ul>
            </div>

            <div className={estilos.secaoCuriosidades}>
                <h3>Curiosidades</h3>
                <p>Dragon Ball é uma franquia com uma rica história e muitos fatos interessantes. Aqui estão algumas curiosidades:</p>
                <ul>
                    <li><strong>Popularidade Global:</strong> Dragon Ball é uma das franquias de anime e mangá mais vendidas de todos os tempos, com milhões de cópias de mangás vendidas e uma vasta base de fãs ao redor do mundo.</li>
                    <li><strong>Influência Cultural:</strong> A série influenciou muitos outros trabalhos de mangá e anime, além de ter um impacto significativo na cultura pop global.</li>
                    <li><strong>Goku como Símbolo:</strong> O personagem Son Goku é amplamente reconhecido e é um ícone cultural que simboliza a luta pela justiça e a busca por autodesenvolvimento.</li>
                </ul>
            </div>

            <a className={estilos.btSaberMais}>Saber mais</a>
        </div>
    );
}

export default Sobre;
